<template>
    <v-card elevation="0" class="card-shadow my-4">
        <v-row class="pa-3 card-box">
            <v-col cols="3" class="align-self-center pa-0 ma-0 ml-4">
                <img :src="icons.creditCard" width="65" />
            </v-col>
            <v-col class="align-self-center">
                <p class="pa-0 ma-0 card-info">
                    <span class="card-masked">{{ credentials.card }}</span> <br />
                    <span class="cardholder">
                        {{
                            credentials.cardholder
                                ? credentials.cardholder
                                : "CARDHOLDER CARDHOLDER"
                        }},
                    </span>
                    <span class="expiration_date ml-2">{{ credentials.expiration_date }}</span>
                </p>
            </v-col>
        </v-row>
        <div class="card-label">
            <v-chip
                style="font-size: 11px; padding: 0px 10px;"
                small
                color="primary"
                outlined
                label
            >
                {{ $t("pay.active") }}
            </v-chip>
        </div>
    </v-card>
</template>

<script>
import creditCard from "@/assets/img/cc1.png";

export default {
    name: "CreditCardBox",
    props: ["credentials"],
    data() {
        return {
            icons: { creditCard },
        };
    },
};
</script>

<style scoped>
.card-label {
    position: absolute;
    top: 10px;
    right: 10px;
}

.card-box {
    position: relative;
}
.card-info {
    font-size: 13px !important;
    color: #666666;
}
.cardholder {
    text-transform: uppercase;
}
</style>
